import './Modal.css'

// 1. Change 'location' prop to 'latitude' for clarity
function LocationModal({ open, onClose, latitude, longitude, city, country }) {
  if (!open) return null;

  // 2. Ensure we are converting the specific values to numbers
  const lat = parseFloat(latitude);
  const lng = parseFloat(longitude);

  const hasValidCoords =
    !isNaN(lat) &&
    !isNaN(lng) &&
    lat !== 0 &&
    lng !== 0;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalBox" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-lg font-bold mb-2">Login Location</h3>

        <p className="mb-4">
          📍 {city || "Unknown City"}, {country || "Unknown Country"}
        </p>

        {hasValidCoords ? (
          <iframe
            title="map"
            width="100%"
            height="260"
            style={{ border: 0, borderRadius: 10 }}
            loading="lazy"
            allowFullScreen
            /* 3. Corrected standard Google Maps Embed URL */
            src={`https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`}
          />
        ) : (
          <div className="py-10 text-center">
            <p style={{ color: "red", fontWeight: "bold" }}>
              ❌ Invalid location coordinates
            </p>
            <p className="text-xs text-gray-500">Lat: {latitude} | Lng: {longitude}</p>
          </div>
        )}

        <button onClick={onClose} className="closeBtn mt-4">
          Close
        </button>
      </div>
    </div>
  );
}

export default LocationModal;

